import Layout from '~/layouts/blank.vue';
import { FeedbackForm, } from './index';

interface FeedbackFormOptions {
	elementToMount: string;
	id: string;
	reasons: string[];
}

function isOptionWithConfig(obj: unknown): obj is FeedbackFormOptions {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
	const objAny = obj as any;

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	return typeof objAny.elementToMount === 'string' && typeof objAny.id === 'string' && Array.isArray(objAny.reasons);
}

function initFeedbackForm(e: CustomEventInit<FeedbackFormOptions>) {
	const options = e.detail;
	if (options === undefined || !isOptionWithConfig(options)) {
		console.error('Invalid options to setup FeedbackForm app', options);
		return;
	}

	FeedbackForm(Layout, {
		id: options.id,
		reasons: options.reasons,
	}, options.elementToMount);
}

const swWindow = window as { sw? : { feedbackForm: boolean, }, };
swWindow.sw = swWindow.sw ?? {
	feedbackForm: false,
};

if (!swWindow.sw.feedbackForm) {
	// Only add one listner if script added multiple times
	window.addEventListener('sw:feedback-form:init', initFeedbackForm);
	swWindow.sw.feedbackForm = true;
}
